/**
 * Platform Kullanım Şartları ve KVKK Aydınlatma Metni
 * Diyetisyen ve danışan kayıt sürecinde kabul ettirilir.
 */

export const TERMS_VERSION = '1.0';

export const TERMS_TITLE = 'Kullanım Şartları ve Aydınlatma Metni';

export const TERMS_CONTENT = `
## 1. Taraflar ve Kapsam

Bu metin, platformu kullanan **diyetisyen** ve **danışan** (kullanıcı) ile platform işletmecisi arasındaki hukuki ilişkiyi ve Kişisel Verilerin Korunması Kanunu (KVKK) kapsamındaki aydınlatma yükümlülüğünü düzenler. Platforma üye olarak veya hizmetleri kullanarak bu şartları kabul etmiş sayılırsınız.

## 2. Hizmetin Sunuluşu

Platform, diyetisyenler ile danışanları buluşturan, randevu, diyet programı, yemek takibi ve mesajlaşma gibi dijital diyet danışmanlığı hizmetlerini sunar. Hizmetler "olduğu gibi" sunulur; platform, danışmanlık sonuçları veya sağlık etkileri konusunda garanti vermez. Tıbbi teşhis ve tedavi yerine geçmez.

## 3. Kişisel Verilerin İşlenmesi ve Paylaşımı

**3.1 Toplanan veriler:** Kayıt ve hizmet sürecinde ad, soyad, e-posta adresi, telefon numarası, doğum tarihi, cinsiyet, kilo/boy, beslenme alışkanlıkları ve sağlık hedefleri gibi kişisel verileriniz toplanabilir.

**3.2 Verilerin platformda kullanımı:**  
- **Danışanlar için:** E-posta adresiniz, adınız, soyadınız ve (varsa) telefon numaranız, bağlı olduğunuz diyetisyen ile paylaşılır. Diyetisyeniniz sizi tanımak, program hazırlamak ve iletişim kurmak için bu bilgileri kullanır.  
- **Diyetisyenler için:** Ad, soyad, e-posta, telefon, uzmanlık ve özgeçmiş bilgileriniz, "Online danışan almak istiyorum" seçeneğini işaretlemeniz hâlinde platformun diyetisyen listesinde (diyetisyen seçim sayfasında) görüntülenebilir. Böylece danışanlar sizi bulup iletişime geçebilir.

**3.3 Paylaşımın amacı:** Verileriniz, hizmetin ifası, randevu ve program yönetimi, platform güvenliği ve yasal yükümlülükler kapsamında işlenir ve yalnızca bu amaçlarla ilgili taraflarla (bağlı diyetisyeniniz veya sizin danışanlarınız) paylaşılır.

## 4. KVKK Aydınlatma

Veri sorumlusu olarak kişisel verileriniz; KVKK’nın 5. ve 6. maddelerinde belirtilen şartlar çerçevesinde, açık rızanız ve/veya kanuni sebeplerle işlenebilir. Verileriniz, hizmet sunumu, sözleşme ve yasal zorunluluklar kapsamında saklanır. Haklarınız (bilgi talep etme, düzeltme, silme, itiraz vb.) KVKK’da tanımlanan çerçevede kullanılabilir; talepleriniz için platform iletişim kanallarından başvurabilirsiniz.

## 5. Kullanıcı Yükümlülükleri

- Doğru ve güncel bilgi vermekle yükümlüsünüz.  
- Platformu yalnızca mevzuata ve bu şartlara uygun kullanacaksınız.  
- Şifrenizi ve hesap güvenliğini kendiniz korumakla yükümlüsünüz.  
- Platform üzerinden verilen diyet önerileri genel bilgilendirme niteliğindedir; özel sağlık durumunuz için mutlaka bir sağlık kuruluşuna danışınız.

## 6. Fikri Mülkiyet ve İçerik

Platform arayüzü, metinleri ve tasarımına ilişkin haklar işletmeye aittir. Kullanıcılar, yükledikleri içerikten kendileri sorumludur.

## 7. Değişiklik ve Sona Erme

Platform, bu şartları ve aydınlatma metnini önceden duyurmak suretiyle güncelleyebilir. Üyelik, kullanıcı veya platform tarafından sonlandırılabilir; sona erme hâlinde veri saklama süreleri mevzuata uygun şekilde uygulanır.

## 8. Uygulanacak Hukuk ve İletişim

Bu şartlara Türkiye Cumhuriyeti kanunları uygulanır. Uyuşmazlıklarda Türkiye mahkemeleri ve icra daireleri yetkilidir. Sorularınız için platform üzerindeki iletişim bilgilerini kullanabilirsiniz.

---

**Özet:** Platforma üye olarak; adınız, soyadınız, e-posta ve telefon bilgilerinizin ilgili diyetisyen(ler) ile paylaşılacağını, diyetisyen iseniz profil bilgilerinizin (onayınızla) sitede listeleneceğini ve KVKK aydınlatma metnini okuduğunuzu, anladığınızı ve kabul ettiğinizi beyan edersiniz.
`.trim();
